module.exports = __webpack_public_path__ + "media/images/right-b94371d8.svg";